import { Flex } from "@chakra-ui/react";
import { PageThumbnail } from "./PageThumbnail";
import { useReleasePagesData } from "../../hooks/hookstate/useReleasePagesData";
import { useReadingDirection } from "../../hooks/useReadingDirection";
import { useReleaseData } from "../../hooks/hookstate/useReleaseData";
import { AllPagesBottomBar } from "./AllPagesBottomBar";
import { useCallback, useEffect, useRef, useState } from "react";
import { Page } from "../../../../types";
import { useReaderNavigation } from "../../hooks/useReaderNavigation";
import { SLIDE_IN_MENUS } from "../../../root/constants";
import { SlideInHeader } from "../../../../components/slideInMenu/components/SlideInHeader";

export function AllPagesMenu({ onCloseMenu }: { onCloseMenu?: () => void }) {
  const { comicIsVertical } = useReadingDirection();
  const { releasePagesData } = useReleasePagesData();
  const { releaseData } = useReleaseData();
  const { activePage, goToPage } = useReaderNavigation();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const [pages, setPages] = useState<Page[]>([]);
  useEffect(() => {
    if (!releasePagesData) return;
    setPages(releasePagesData?.slice(0, activePage + 10) || []);
  }, [releasePagesData]);

  const showMorePages = useCallback(() => {
    if (!releasePagesData) return;
    setPages((prev) => releasePagesData.slice(0, prev.length + 10));
  }, [releasePagesData]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      const is500pxAboveScrollBottom =
        scrollContainer.scrollHeight -
          (scrollContainer.scrollTop + scrollContainer.clientHeight) <=
        500;

      if (is500pxAboveScrollBottom) {
        showMorePages();
      }
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [showMorePages]);

  return (
    <Flex flexDirection="column" height="100%">
      <SlideInHeader
        openMenu={SLIDE_IN_MENUS.allPages}
        onCloseMenu={onCloseMenu}
      />
      <Flex
        ref={scrollContainerRef}
        className="styled-scrollbar"
        p="24px"
        pb="0px"
        width="100%"
        flexGrow={1}
        overflowY="auto"
        flexDirection={comicIsVertical ? "column" : "row"}
        flexFlow={comicIsVertical ? undefined : "wrap"}
        position="relative"
        justifyContent={comicIsVertical ? "flex-start" : "space-between"}
        alignItems={comicIsVertical ? "center" : "flex-start"}
      >
        {pages.length &&
          pages.map((page) => (
            <PageThumbnail
              page={page}
              blurIfPaid={releaseData?.paid_access_thumbnail_blur}
              goToPage={goToPage}
              activePage={activePage}
            />
          ))}
      </Flex>
      <AllPagesBottomBar />
    </Flex>
  );
}
